import Amplify from 'aws-amplify'
import awsConfig from './config'

Amplify.configure(awsConfig)
